module.exports = __webpack_public_path__ + "static/media/bongoMi.96a47fb6.wav";